export default __webpack_public_path__ + "static/media/louise-de-marillac.914d69a5.png";